<template>
    <div class="card mb-3">
        <div class="card-header">
            <i class="fa fa-list"></i> 
            {{ $t('legend') }}
        </div>
        <div class="card-body">
            <div class="row">
                <div class="form-group col-md-12">
                <h5>{{ $t('project.form.companyStatus') }}</h5>
                <ul class=legend>
                    <li><span class="companyStatus_1"></span>{{ $t("project.form.companyStatuses.actif")}}</li>
                  <li>
                    <span class="exitReason_0"></span>{{ $t("project.exit.form.person.reasons.notDefined")}}
                  </li>

                  <li><span class="exitReason_1"></span>{{ $t("project.exit.form.person.reasons.publicCompany")}}</li>
                    <li><span class="exitReason_2"></span>{{ $t("project.exit.form.person.reasons.saleOfCompany")}}</li>
                    <li><span class="exitReason_3"></span>{{ $t("project.exit.form.person.reasons.bankruptcy")}}</li>
                    <li><span class="exitReason_4"></span>{{ $t("project.exit.form.person.reasons.closing")}}</li>
                    <li><span class="exitReason_5"></span>{{ $t("project.exit.form.person.reasons.nonOperative")}}</li>
                    <li><span class="exitReason_6"></span>{{ $t("project.exit.form.person.reasons.totalShareSales")}}</li>
                    <li><span class="exitReason_7"></span>{{ $t("project.exit.form.person.reasons.partialShareSales")}}</li>
                </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ProjectStatusLegend',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>




// WEBPACK FOOTER //
// src/components/projects/ProjectStatusLegend.vue